import e, { Component as t } from "react";
import r from "react-dom";
import o from "../../../../node_modules/classnames/index.js";
import n from "../../../utils/ObjectUtils.js";
function i(e) {
  if (void 0 === e) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function c(e, t) {
  for (var r = 0; r < t.length; r++) {
    var o = t[r];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function p(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function s(e) {
  return (s = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function a(e, t) {
  return (a = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
var l = function (t) {
  !function (e, t) {
    if ("function" != typeof t && null !== t) throw TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && a(e, t);
  }(m, t);
  var l,
    u,
    f,
    y = (l = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }(), function () {
      var e,
        t,
        r = s(m);
      if (l) {
        var o = s(this).constructor;
        t = Reflect.construct(r, arguments, o);
      } else t = r.apply(this, arguments);
      return (e = t) && ("object" == (e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e) || "function" == typeof e) ? e : i(this);
    });
  function m() {
    var e;
    return !function (e, t) {
      if (!(e instanceof t)) throw TypeError("Cannot call a class as a function");
    }(this, m), e = y.apply(this, arguments), p(i(e), "element", void 0), p(i(e), "itemsWrapper", void 0), p(i(e), "footerElement", void 0), e;
  }
  return u = [{
    key: "renderFooter",
    value: function value() {
      var t = this,
        r = n.getJSXElement(this.props.footer, this.props);
      return r && e.createElement("div", {
        ref: function ref(e) {
          return t.footerElement = e;
        },
        className: "dropdown__footer "
      }, r);
    }
  }, {
    key: "renderElement",
    value: function value() {
      var t,
        r,
        i = this,
        c = o("kaseya-ui-dropdown__panel", this.props.appendTo && "kaseya-ui-dropdown__panel--appended", this.props.panelClassName),
        s = this.renderFooter(),
        a = n.omitKeys(this.props, ["appendTo", "filter", "scrollHeight", "panelClassName", "panelStyle", "footer", "onClick"]);
      return e.createElement("div", (t = function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = null != arguments[t] ? arguments[t] : {},
            o = Object.keys(r);
          "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function (e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
          }))), o.forEach(function (t) {
            p(e, t, r[t]);
          });
        }
        return e;
      }({}, a), r = r = {
        ref: function ref(e) {
          return i.element = e;
        },
        className: c,
        style: this.props.panelStyle,
        onClick: this.props.onClick
      }, Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : function (e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          r.push.apply(r, o);
        }
        return r;
      }(Object(r)).forEach(function (e) {
        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
      }), t), this.props.filter, e.createElement("div", {
        ref: function ref(e) {
          return i.itemsWrapper = e;
        },
        className: "dropdown__items__wrapper",
        style: {
          maxHeight: this.props.scrollHeight || "auto"
        }
      }, e.createElement("ul", {
        className: "dropdown__items",
        role: "listbox"
      }, this.props.children)), s);
    }
  }, {
    key: "render",
    value: function value() {
      var e = this.renderElement();
      return this.props.appendTo ? r.createPortal(e, this.props.appendTo) : e;
    }
  }], c(m.prototype, u), f && c(m, f), m;
}(t);
export { l as DropdownPanel };